import { observer } from 'mobx-react-lite'
import './BaseViewFieldTemplate.css'

/**
 * Рядок, який ядро загорнуло в `<div dangerouslySetInnerHTML>`, або `undefined`.
 *
 * Ядровий `FormField` у режимі перегляду перетворює **будь-яке** рядкове
 * значення на `<div dangerouslySetInnerHTML={{ __html: value }} />`
 * (`Core/UI/Form/Components/FormField/FormField.tsx`, «Преобразование строк в
 * HTML»). Тобто «Повна назва» клієнта `<img src=x onerror=…>`, збережена
 * менеджером, виконувалася в браузері кожного, хто відкрив картку, —
 * збережений XSS. Ядро — сабмодуль, тож елемент розгортаємо тут: шаблон
 * перегляду ядро бере з `FormConfig.defaultViewFieldTemplate`, і рендериться
 * вже те, що повернув шаблон.
 */
export const viewHtmlOf = (children) => {
    if (typeof children !== 'object' || children === null) return undefined

    const html = children.props?.dangerouslySetInnerHTML?.__html

    return typeof html === 'string' ? html : undefined
}

/**
 * Шаблон поля в режимі перегляду (картки клієнта, перевізника, співробітника…).
 *
 * Значення, яке ядро віддало як HTML, показуємо **текстом** — React його
 * екранує. Rich-text поля (`description`, тіло листа) сюди як HTML не
 * приходять: їхній `view` — `renderRichTextView` (tiptap, лише вузли схеми),
 * а поле з власним `view` ядро малює без цього перетворення.
 */
export const BaseViewFieldTemplate = observer(({ field, children }) => {
    if (field === undefined) return null

    const html = viewHtmlOf(children)
    const content = html === undefined ? children : <div>{html}</div>

    // Визначаємо, чи є значення порожнім
    const isEmpty = children === null || children === undefined || children === '' || children === '-' || html === '-'

    return (
        <div className="form-field-view">
            {field.label && <div className="field-view-label">{field.label}</div>}
            <div className={`field-view-value ${isEmpty ? 'is-empty' : ''}`}>{isEmpty ? '—' : content}</div>
        </div>
    )
})
